import { createVNode as _createVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "sp ico_back" }, "뒤로가기", -1)
const _hoisted_2 = { class: "tit_txt" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "sp ico_bar_search" }, "검색", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("a", {
      href: "#",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.moveToPreviousPage && _ctx.moveToPreviousPage(...args)), ["prevent"])),
      class: "btn_menu"
    }, [
      _hoisted_1
    ]),
    _createVNode("h1", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode("a", {
      href: "#",
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.moveToSearchPage && _ctx.moveToSearchPage(...args)), ["prevent"])),
      class: "btn_search"
    }, [
      _hoisted_3
    ])
  ], 64))
}